import { Content, Header, Page } from "@backstage/core-components";
import { useEntity } from "@backstage/plugin-catalog-react";
import React from "react";
import { EntityApiDefinitionCard } from "@backstage/plugin-api-docs";


export const ApiPage = () => {
    const { entity } = useEntity()
    return (
        <Page themeId="home">
            <Header title={entity.metadata.name} pageTitleOverride="Home"></Header>
            <Content>
                <EntityApiDefinitionCard />
            </Content>
        </Page>
    )
}